// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"7c6b0048","162":"d991f30c","300":"d6816289","407":"a48b0f01","428":"dd866b32","956":"9a82b243"}[chunkId] + ".css";
};